import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import PopUp from "../../../componente/popup";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

function CadKit() {
  const [listakititens, setlistakititens] = useState([]);
  const [listaproduto, setlistaproduto] = useState([]);
  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodkit, setedtcodkit] = useState(0);
  const [edtdescricao, setedtdescricao] = useState("");
  const [edtqtdeitens, setedtqtdeitens] = useState(0);
  const [edtvalor, setedtvalor] = useState(0);

  const [edtcodkititens, setedtcodkititens] = useState(0);
  const [edtqtde, setedtqtde] = useState(0);
  const [edtpreco, setedtpreco] = useState(0);
  const [edttotal, setedttotal] = useState(0);
  const [edtcodproduto, setedtcodproduto] = useState(0);

  const [novo, setnovo] = useState(false);
  const [excluido, setexcluido] = useState(false);

  const [qtdeItensLanc, setqtdeItensLanc] = useState(0);
  const [subtotal, setsubtotal] = useState(0);
  const [itens, setitens] = useState(0);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setedtcodkit(cad.codkit);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      ExcluirCad();
      setIsOpenMotivoExclusao(false);
      ListarKit();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    function ListarKitItens() {
      api
        .get("v1/cadastro/kititens", {
          params: {
            codkit: edtcodkit,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistakititens(response.data);
          CalculaTotal(response.data);
          CalculaItens(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarKitItens();
  }, [qtdeItensLanc, edtcodkit, edtcodkititens]);

  useEffect(() => {
    function ListarProduto() {
      api
        .get("v1/cadastro/produto", {
          params: {
            busca: "",
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        })
        .then(function (response) {
          setlistaproduto(response.data);
        })
        .catch(function (err) {
          console.log("ops! ocorreu um erro: " + err);
        });
    }

    ListarProduto();
  }, [showform]);


  function ListarKit() {
    api
      .get("v1/cadastro/kit", {
        params: {
          busca: abusca,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
        setexcluido(false);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }
  useEffect(() => {
    ListarKit();
  }, [abusca, showform, excluido, handleConfirma]);

  function CadastrarComItem() {
    api
      .post(
        "v1/cadastro/kit",
        {
          codkit: edtcodkit,
          descricao: edtdescricao,
          qtdeitens: edtqtdeitens,
          valor: edtvalor,
          codusuario: localStorage.getItem("tempCodUsuario"),
          excluido: "N",
          codempresa: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then((response) => {
        setedtcodkit(response.data.codkit);
        setnovo(false);

        api
          .post(
            "v1/cadastro/kititens",
            {
              qtde: edtqtde,
              preco: edtpreco,
              total: edttotal,
              codusuario: localStorage.getItem("tempCodUsuario"),
              excluido: "N",
              codempresa: 1,
              codkit: response.data.codkit,
              codproduto: edtcodproduto,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
              },
            }
          )
          .then(() => {
            setshowform(true);

            setedtqtde(0);
            setedtpreco(0);
            setedttotal(0);

            setqtdeItensLanc(listakititens.length + 1);
          })
          .catch(function (err) {
            console.log("ops! ocorreu um erro: " + err);
          });
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/kit",
        {
          codkit: edtcodkit,
          descricao: edtdescricao,
          qtdeitens: edtqtdeitens,
          valor: edtvalor,
          codusuario: localStorage.getItem("tempCodUsuario"),
          excluido: "N",
          codempresa: 1,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then((response) => {
        setedtcodkit(response.data.codkit);
        setnovo(false);        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function addProduto() {
    VerificaCad();
  }

  function EditarComItem() {
    api
      .put(
        "v1/cadastro/kit",
        {
          codkit: edtcodkit,
          descricao: edtdescricao,
          qtdeitens: listakititens.length,
          valor: 0,
          codusuario: localStorage.getItem("tempCodUsuario"),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        if (edtcodkititens === 0) {
          api
            .post(
              "v1/cadastro/kititens",
              {
                qtde: edtqtde,
                preco: edtpreco,
                total: edttotal,
                codusuario: localStorage.getItem("tempCodUsuario"),
                excluido: "N",
                codempresa: 1,
                codkit: edtcodkit,
                codproduto: edtcodproduto,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
              }
            )
            .then(() => {
              setshowform(true);

              setedtqtde(0);
              setedtpreco(0);
              setedttotal(0);
              setedtcodproduto(0);

              setqtdeItensLanc(listakititens.length + 1);
            })
            .catch(function (err) {
              console.log("ops! ocorreu um erro: " + err);
            });
        } else {
          api
            .put(
              "v1/cadastro/kititens",
              {
                qtde: edtqtde,
                preco: edtpreco,
                total: edttotal,
                codkititens: edtcodkititens,
                codproduto: edtcodproduto,
              },
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
                },
              }
            )
            .then(() => {
              setshowform(true);

              setedtqtde(0);
              setedtpreco(0);
              setedttotal(0);
              setedtcodkititens(0);
              setedtcodproduto(0);

              setqtdeItensLanc(listakititens.length);
            })
            .catch(function (err) {
              console.log("ops! ocorreu um erro: " + err);
            });
        }
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/kit",
        {
          codkit: edtcodkit,
          descricao: edtdescricao,
          qtdeitens: listakititens.length,
          valor: subtotal,
          codusuario: localStorage.getItem("tempCodUsuario"),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        setshowform(false);        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function VerificaCad() {
    novo ? CadastrarComItem() : EditarComItem();
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
  }

  function ExcluirCad() {
    api
      .delete("v1/cadastro/kit", {
        params: {
          codkit: edtcodkit,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        setexcluido(true);      
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function ExcluirCadItem(props) {
    api
      .delete("v1/cadastro/kititens", {
        params: {
          codkititens: props.codkititens,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        setqtdeItensLanc(listakititens.length - 1);        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function EditarItens(cad) {
    setedtcodproduto(cad.codproduto);
    setedtqtde(cad.qtde);
    setedtpreco(cad.preco);
    setedttotal(cad.total);
    setedtcodkititens(cad.codkititens);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodkit(0);
    setedtdescricao("");
    setedtqtdeitens(0);
    setedtvalor(0);

    setedtcodproduto(0);
    setedtqtde(0);
    setedtpreco(0);
    setedttotal(0);

    setqtdeItensLanc(0);
  }

  function openModalEditar(props) {
    setshowform(true);
    setnovo(false);

    setedtcodkit(props.codkit);
    setedtdescricao(props.descricao);
    setedtqtdeitens(props.qtdeitens);
    setedtvalor(props.valor);

    setqtdeItensLanc(props.qtdeitens);
  }

  function CalculaTotal(props) {
    setsubtotal(
      props.reduce(function (subtotal, props) {
        return subtotal + props.total;
      }, 0)
    );
  }

  function CalculaItens(props) {
    setitens(
      props.reduce(function (item, props) {
        return item + props.qtde;
      }, 0)
    );
  }

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
          <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
              </div>              

              <div className="modal-body">
                <form>
                  <div className="row col-sm-12">
                    <div className="col-sm-9">
                      <label htmlFor="descricao" className="form-label">
                        Descrição
                      </label>
                      <input
                        type="text"
                        id="descricao"
                        className="form-control"
                        placeholder="Descrição"
                        value={edtdescricao}
                        onChange={(e) => setedtdescricao(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-4">
                      <label htmlFor="produto" className="form-label">
                        Produto
                      </label>
                      <select
                        id="produto"
                        className="form-select"
                        value={edtcodproduto}
                        onChange={(e) => setedtcodproduto(e.target.value)}
                      >
                        <option value="0">Escolha o produto</option>
                        {listaproduto.map(function (prod) {
                          return (
                            <option
                              key={prod.codproduto}
                              value={prod.codproduto}
                            >
                              {prod.descricao}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    <div className="col-sm-2">
                      <label htmlFor="qtde" className="form-label">
                        Qtde
                      </label>
                      <input
                        type="number"
                        id="qtde"
                        className="form-control"
                        placeholder="Qtde"
                        value={edtqtde}
                        onChange={(e) => {
                          setedtqtde(e.target.value);
                          setedttotal(e.target.value * edtpreco);
                        }}
                      />
                    </div>

                    <div className="col-sm-2">
                      <label htmlFor="preco" className="form-label">
                        Preço
                      </label>
                      <input
                        type="number"
                        id="preco"
                        className="form-control"
                        placeholder="Preço"
                        value={edtpreco}
                        onChange={(e) => {
                          setedtpreco(e.target.value);
                          setedttotal(e.target.value * edtqtde);
                        }}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="total" className="form-label">
                        Total
                      </label>
                      <input
                        disabled
                        type="number"
                        id="total"
                        className="form-control"
                        placeholder="Total"
                        value={edttotal}
                        onChange={(e) => setedttotal(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-1 d-flex justify-content-center">
                      <button
                        type="button"
                        id="btnadd"
                        className="btn btn-success"
                        onClick={addProduto}
                      >
                        Adicionar
                      </button>
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="row tabela">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th className="codigo">Código</th>
                            <th className="razao">Descrição</th>
                            <th className="cnpj">Qtde</th>
                            <th className="cnpj">Preço</th>
                            <th className="cnpj">Total</th>
                            <th className="acao">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {listakititens.map(function (item) {
                            return (
                              <tr key={item.codkititens}>
                                <th>{item.codproduto}</th>
                                <th>{item.descricao}</th>
                                <th>{item.qtde}</th>
                                <th>{item.preco}</th>
                                <th>{item.total}</th>
                                <th>
                                  <div className="d-flex justify-content-center">
                                    <button
                                      type="button"
                                      id="btneditaritem"
                                      className="btn fa-regular fa-pen-to-square"
                                      onClick={() => EditarItens(item)}
                                    ></button>
                                    <button
                                      type="button"
                                      id="btnexcluiritem"
                                      className="btn fa-solid fa-trash"
                                      onClick={() => ExcluirCadItem(item)}
                                    ></button>
                                  </div>
                                </th>
                              </tr>
                            );
                          })}
                        </tbody>
                        <tfoot>
                          <tr>
                            <th colSpan={5}>
                              Quantidade de Registros: {listakititens.length}
                            </th>
                            <th colSpan={5}>Itens: {itens}</th>
                            <th colSpan={5}>Total: {subtotal}</th>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    id="btncancelar"
                    className="btn btn-danger ms-4"
                    onClick={closeModal}
                  >
                    Cancelar
                  </button>
                  <button
                    id="btnSalvar"
                    className="btn btn-success ms-4"
                    onClick={Salvar}
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Kits</h1>
          <p className="ms-4">
            Rotina para cadastrar todos os modelos de kits da empresa.
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-10">
            <label className="d-block" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou descrição"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => setabusca(e.target.value)}
            />
          </div>
          <div className="col-2 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/kit")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Descrição</th>
                <th className="cnpj">Qtde Itens</th>
                <th className="fantasia">Valor Kit</th>
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codkit}>
                    <th>{item.codkit}</th>
                    <th>{item.descricao}</th>
                    <th>{item.qtdeitens}</th>
                    <th>{item.valor}</th>
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/kit")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/kit")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </>
  );
}

export default CadKit;
